import {
  PaymentMethodCardResponse,
  PaymentMethodCardListResponse,
  PaymentMethodResponse,
  PaymentMethodListResponse,
  Card3dsChallengeResponse,
} from '@API/src/component/home/payment/types';

export const isTypePaymentMethodResponse = (
  arg: any,
): arg is PaymentMethodResponse =>
  arg !== null &&
  typeof arg === 'object' &&
  typeof arg.child === 'object';

export const isTypePaymentMethodListResponse = (
  arg: any,
): arg is PaymentMethodListResponse =>
  arg !== null &&
  typeof arg === 'object' &&
  Array.isArray(arg) &&
  (arg.length === 0 || isTypePaymentMethodResponse(arg[0]));

export const isTypePaymentMethodCardResponse = (
  arg: any,
): arg is PaymentMethodCardResponse =>
  arg !== null &&
  typeof arg === 'object' &&
  typeof arg.cardSeq === 'string' &&
  typeof arg.cardNo === 'string' &&
  typeof arg.expire === 'string' &&
  typeof arg.holderName === 'string';

export const isTypePaymentMethodCardListResponse = (
  arg: any,
): arg is PaymentMethodCardListResponse =>
  arg !== null &&
  typeof arg === 'object' &&
  Array.isArray(arg) &&
  (arg.length === 0 || isTypePaymentMethodCardResponse(arg[0]));

/**
 * クレジットカード新規登録時、3Dセキュアのチャレンジ認証が必要な場合に
 * バックエンドが返すレスポンスの型ガード。
 * (カード一覧は配列だが、こちらは配列ではない単一オブジェクトのため区別できる)
 */
export const isTypeCard3dsChallengeResponse = (
  arg: any,
): arg is Card3dsChallengeResponse =>
  arg !== null &&
  typeof arg === 'object' &&
  !Array.isArray(arg) &&
  arg.requires3ds === true &&
  typeof arg.redirectUrl === 'string' &&
  typeof arg.accessPass === 'string';
